export enum WorkplaceWorkersStatus {
	ACCEPTED = 'ACCEPTED',
	PENDING = 'PENDING',
	PENDING_REGISTRATION = 'PENDING_REGISTRATION',
}
